import React from 'react';
import LandingHeader from './LandingHeader';
import LandingFooter from './LandingFooter';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col" dir="rtl">
   
      <main className="flex-grow container mx-auto px-4 py-24 md:py-32">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 max-w-4xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold text-[#1D2035] mb-8">سياسة الخصوصية</h1>
          
          <div className="prose prose-lg max-w-none text-gray-600 space-y-6">
            <p className="font-semibold">تاريخ النفاذ: 01 سبتمبر 2022</p>
            
            <p>
              تدير شركة ديوان التشريع الليبي لتكنولوجيا المعلومات ("نحن"، "نحن"، أو "شركتنا") موقع الويب http://libyanlegislation.ly/ وتطبيقات الهاتف المحمول Libyan Legislation.
            </p>

            <h2 className="text-xl font-bold text-[#1D2035] mt-8 mb-4">التعاريف</h2>
            
            <h3 className="text-lg font-semibold text-[#1D2035] mb-2">الخدمة</h3>
            <p>الخدمة تعني موقع الويب وتطبيقات الهاتف المحمول Libyan Legislation المشغلة بواسطة شركة ديوان التشريع الليبي لتكنولوجيا المعلومات.</p>

            <h3 className="text-lg font-semibold text-[#1D2035] mb-2">البيانات الشخصية</h3>
            <p>البيانات الشخصية هي المعلومات المتعلقة بفرد يمكن التعرف عليه.</p>

            <h3 className="text-lg font-semibold text-[#1D2035] mb-2">ملفات تعريف الارتباط</h3>
            <p>ملفات تعريف الارتباط هي ملفات صغيرة تُخزن على جهازك لتحسين تجربة الاستخدام.</p>

            <h2 className="text-xl font-bold text-[#1D2035] mt-8 mb-4">استخدام البيانات</h2>
            <p>نستخدم بياناتك لتوفير وتحسين الخدمة، والتواصل معك، وضمان الأمان.</p>

            <h2 className="text-xl font-bold text-[#1D2035] mt-8 mb-4">كشف البيانات</h2>
            <p>قد يتم الكشف عن بياناتك لأسباب قانونية أو امتثالًا للوائح الحكومية.</p>

            <h2 className="text-xl font-bold text-[#1D2035] mt-8 mb-4">أمان البيانات</h2>
            <p>نحن نحافظ على أمان بياناتك بأفضل الطرق المتاحة، ولكن لا يوجد نظام آمن بنسبة 100%.</p>

            <h2 className="text-xl font-bold text-[#1D2035] mt-8 mb-4">تغييرات على هذه السياسة</h2>
            <p>قد نقوم بتحديث هذه السياسة من حين لآخر، وسيتم إخطار المستخدمين بالتعديلات الجوهرية.</p>

            <h2 className="text-xl font-bold text-[#1D2035] mt-8 mb-4">تواصل معنا</h2>
            <p>إذا كان لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال بنا:</p>
            <ul className="list-disc list-inside space-y-2 mr-4">
              <li>البريد الإلكتروني: info@libyanlegislation.ly</li>
              <li>الهاتف: +218926522020 أو +218917842020</li>
              <li>
                عبر موقعنا: <a href="https://libyanlegislation.ly/en/contact-us/" className="text-blue-600 hover:underline">https://libyanlegislation.ly/en/contact-us/</a>
              </li>
            </ul>

            <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-gray-500">
              © 2022 Cube technology company
            </div>
          </div>
        </div>
      </main>
     
    </div>
  );
}
